import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/live-monitoring/live-monitoring.css";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import LMFilters from "../../components/live-monitoring/LMFilters";
import { selectAuth } from "../../components/auth/auth.selector";
import AAAGACards from "../../components/live-monitoring/AAAGACards";
import { currentDateOfTheMonth } from "../../components/common-data/Converts";
import CheckinsShiftwise from "../../components/live-monitoring/shiftwise-checkins/CheckinsShiftwise";
import TrainerAttendance from "../../components/live-monitoring/TrainerAttendance";
import ReceptionistAttendance from "../../components/live-monitoring/ReceptionistAttendance";
import AssignedNotAssignedTab from "../../components/live-monitoring/assigned-notassigned-members/AssignedNotAssignedTab";
import HelmetWrapper from "../../HelmetWrapper";

const LiveMonitoring = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;
  const isAdmin = userInfoData?.account_type === "admin";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const initialFilters = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: userInfoData?.gym_name || "",
          value: userInfoData?.gym_id || "",
        }
      : "",
    selectedStartDate: currentDateOfTheMonth,
    selectedEndDate: currentDateOfTheMonth,
    selectedStartTime: "",
    selectedEndTime: "",
  };
  const [allFilters, setAllFilters] = useState(initialFilters);
  const iniFilters = {
    gym_id: allFilters.selectedGym?.value || "",
    date_from: allFilters.selectedStartDate || "",
    date_to: allFilters.selectedEndDate || "",
    start_time: allFilters.selectedStartTime || "",
    end_time: allFilters.selectedEndTime || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const onClickReset = () => {
    setAllFilters(initialFilters);
    setFilters(iniFilters);
  };

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      date_from: allFilters.selectedStartDate || "",
      date_to: allFilters.selectedEndDate || "",
      start_time: allFilters.selectedStartTime || "",
      end_time: allFilters.selectedEndTime || "",
    }));
  }, [allFilters]);

  return (
    <HelmetWrapper title="Live Monitoring System">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <MealsStructure text={"Live Monitoring"} />
          </Col>
        </Row>
        <Row>
          <Col>
            <LMFilters
              userInfoData={userInfoData}
              allFilters={allFilters}
              setAllFilters={setAllFilters}
              onClickReset={onClickReset}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <AAAGACards userInfoData={userInfoData} prevFilters={filters} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col>
            <MealsStructure text={"Trainer Attendance/Checkins"} />
          </Col>
        </Row>
        <Row>
          <Col>
            <TrainerAttendance
              userInfoData={userInfoData}
              prevFilters={filters}
            />
          </Col>
        </Row>
        <br />
        <Row>
          <Col>
            <MealsStructure text={"Sales Executive Attendance/Checkins"} />
          </Col>
        </Row>
        <Row>
          <Col>
            <ReceptionistAttendance
              userInfoData={userInfoData}
              prevFilters={filters}
            />
          </Col>
        </Row>
        <br />
        <Row>
          <Col>
            <MealsStructure text={"Assigned and not assigned members"} />
          </Col>
        </Row>
        <Row>
          <Col>
            <AssignedNotAssignedTab
              userInfoData={userInfoData}
              prevFilters={filters}
            />
          </Col>
        </Row>
        <br />
        <Row>
          <Col>
            <MealsStructure text={"Checkins In Every Shift"} />
          </Col>
        </Row>
        <Row>
          <Col>
            <CheckinsShiftwise
              userInfoData={userInfoData}
              prevFilters={filters}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default LiveMonitoring;
